document.addEventListener('DOMContentLoaded', function() {
  const menu = document.getElementById('navbar-menu');
  const burger = document.getElementById('navbar-burger');
  const close = document.getElementById('navbar-close');
  const backdrop = document.getElementById('navbar-backdrop');

  const addCloseMenuEvent = (element: HTMLElement | null) => {
    element?.addEventListener('click', function() {
      if (!menu?.classList.contains('hidden')) {
        menu?.classList.add('hidden');
      }
    })
  }

  const addOpenMenuEvent = (element: HTMLElement | null) => {
    element?.addEventListener('click', function() {
      menu?.classList.remove('hidden');
    })
  }

  addOpenMenuEvent(burger);
  addCloseMenuEvent(close);
  addCloseMenuEvent(backdrop);
});
